import {PermissionScope} from "../../services/auth/permission-scope.enum";
import {PermissionGrant} from "../../services/auth/permission-grant.enum";

export class DtoUtils {

  public static initPermissions(permissions: Map<PermissionScope, PermissionGrant>): Map<PermissionScope, PermissionGrant> {
    const permissionMap = new Map<PermissionScope, PermissionGrant>();
    Object.keys(permissions).forEach((k: string) => {
      const key: PermissionScope = PermissionScope[k as keyof typeof PermissionScope];
      // @ts-ignore
      const value = PermissionGrant[permissions[k] as keyof typeof PermissionGrant];
      permissionMap.set(key, value);
    });
    return permissionMap;
  }
}
